import API from '../config/api';
import React, { useState, useEffect } from 'react';

// import {
//   FaBell
// }
// from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import {
  Navbar,
  Nav,
  Container,
  Form,
  FormControl,
  Button,
  NavDropdown,
  Badge
} from 'react-bootstrap';

import { Link, useNavigate } from 'react-router-dom';

function CustomNavbar() {
  // const [wishlistCount,
  // setWishlistCount] =
  // useState(0);

  // const [cartCount,
  // setCartCount] =
  // useState(0);
  const location = useLocation();

  const query = new URLSearchParams(location.search);

  const searchKeyword = query.get('search') || '';

  const [search, setSearch] = useState(searchKeyword);
  const navigate = useNavigate();

  const [showSuggestions, setShowSuggestions] = useState(false);

  const [products, setProducts] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem('userInfo'))
  );
  useEffect(() => {
    setSearch(searchKeyword);
  }, [searchKeyword]);

  useEffect(() => {
    const fetchUser = async () => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));

      if (!userInfo) {
        setUser(null);

        return;
      }

      try {
        const { data } = await axios.get(
          `${API}/users/profile`,

          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`
            }
          }
        );

        setUser({
          ...userInfo,

          ...data
        });

        // const wishlistResponse =
        //   await axios.get(

        //     `${API}/wishlist/${userInfo._id}`

        //   );

        // setWishlistCount(

        //   wishlistResponse.data.length

        // );
        // const cartResponse =
        //   await axios.get(

        //     `${API}/cart/${userInfo._id}`

        //   );

        // setCartCount(

        //   cartResponse.data.length

        // );
      } catch (error) {
        console.log(error);
      }
    };

    fetchUser();

    const fetchProducts = async () => {
      try {
        const { data } = await axios.get(`${API}/products`);

        setProducts(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchProducts();
  }, []);
  useEffect(() => {
    setShowSuggestions(false);
  }, [location.pathname]);

  const logoutHandler = () => {
    localStorage.removeItem('userInfo');

    window.location.href = '/login';
  };
  const searchHandler = (e) => {
    e.preventDefault();

    if (search.trim()) {
      setShowSuggestions(false);

      navigate(`/products?search=${encodeURIComponent(search.trim())}`);
    }
  };
  const filteredProducts = search.trim()
    ? products.filter((product) => {
        const keyword = search.toLowerCase().trim();

        return (
          product.name?.toLowerCase().includes(keyword) ||
          product.category?.toLowerCase().includes(keyword) ||
          product.shortDescription?.toLowerCase().includes(keyword)
        );
      })
    : [];
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));

        if (!userInfo) return;

        const { data } = await axios.get(
          `${API}/notifications/${userInfo.email}`
        );

        setNotifications(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchNotifications();
  }, []);
  const markNotificationAsRead = async (id) => {
    try {
      await axios.put(`${API}/notifications/read/${id}`);

      setNotifications(
        notifications.map((notification) =>
          notification._id === id
            ? {
                ...notification,

                isRead: true
              }
            : notification
        )
      );
    } catch (error) {
      console.log(error);
    }
  };
  const handleNotificationClick = async (notification) => {
    try {
      await markNotificationAsRead(notification._id);

      if (notification.ticketId) {
        navigate(`/ticket/${notification.ticketId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* Viewed = read: when the bell dropdown closes, mark everything still
     unread as read (same behavior as the mobile notification sheet). */
  const markAllNotificationsRead = () => {
    const unreadItems = notifications.filter((n) => !n.isRead);

    if (!unreadItems.length) return;

    unreadItems.forEach((n) => {
      axios
        .put(`${API}/notifications/read/${n._id}`)
        .catch(() => {});
    });

    setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
  };
  const isActive = (path) =>
    path === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(path);

  /* Shared search field (used inline on desktop and as a top row on mobile) */
  const searchInner = (
    <>
      <Form className="d-flex" onSubmit={searchHandler}>
        <FormControl
          type="search"
          placeholder="Search products or categories..."
          aria-label="Search"
          className="shopease-search-input"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);

            setShowSuggestions(true);
          }}
        />
        <Button
          type="submit"
          variant="warning"
          className="shopease-search-btn fw-bold"
        >
          🔍
        </Button>
      </Form>

      {showSuggestions && search && filteredProducts.length > 0 && (
        <div className="shopease-suggestions">
          <div className="shopease-suggestions-head">
            <span>🔎 Suggestions</span>
            <span className="shopease-suggestions-count">
              {Math.min(filteredProducts.length, 5)}
            </span>
          </div>

          {filteredProducts
            .sort((a, b) => {
              const keyword = search.toLowerCase().trim();

              const aStarts = a.name?.toLowerCase().startsWith(keyword);

              const bStarts = b.name?.toLowerCase().startsWith(keyword);

              if (aStarts && !bStarts) return -1;

              if (!aStarts && bStarts) return 1;

              return 0;
            })
            .slice(0, 5)
            .map((product) => (
              <Link
                key={product._id}
                to={`/product/${product._id}`}
                onClick={() => {
                  setSearch('');

                  setShowSuggestions(false);
                }}
                className="shopease-suggestion-item"
              >
                <span className="shopease-sg-thumb">
                  <img src={product.image} alt={product.name} />
                </span>

                <span className="shopease-sg-info">
                  <span className="shopease-sg-name">{product.name}</span>
                  <span className="shopease-sg-cat">{product.category}</span>
                </span>

                <span className="shopease-sg-price">₹{product.price}</span>
                <span className="shopease-sg-arrow">›</span>
              </Link>
            ))}
        </div>
      )}
    </>
  );

  /* Notifications bell + panel (reused inline on desktop and mobile) */
  const renderNotif = (id) => (
    <NavDropdown
      className="shopease-icon-dd ms-xl-1"
      title={
        <span className="position-relative d-inline-block">
          🔔
          {notifications.filter((n) => !n.isRead).length > 0 && (
            <Badge
              bg="danger"
              pill
              className="position-absolute"
              style={{
                top: '-8px',
                right: '-14px',
                fontSize: '0.65rem',
                minWidth: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {notifications.filter((n) => !n.isRead).length}
            </Badge>
          )}
        </span>
      }
      id={id}
      align="end"
      onToggle={(isOpen) => {
        if (!isOpen) markAllNotificationsRead();
      }}
    >
      <div className="shopease-notif">
        <div className="shopease-notif-header">
          <span className="fw-bold">
            <span className="shopease-notif-bell">🔔</span> Notifications
          </span>
          {notifications.filter((n) => !n.isRead).length > 0 && (
            <span className="shopease-notif-unread">
              {notifications.filter((n) => !n.isRead).length} new
            </span>
          )}
        </div>

        {notifications.length === 0 ? (
          <div className="shopease-notif-empty">
            <div className="shopease-notif-empty-icon">🔕</div>
            <div className="fw-semibold mt-1">No notifications</div>
            <small className="text-muted">You're all caught up!</small>
          </div>
        ) : (
          <div className="shopease-notif-list">
            {notifications.slice(0, 6).map((notification) => (
              <button
                type="button"
                key={notification._id}
                className={
                  'shopease-notif-item ' +
                  (!notification.isRead ? 'shopease-notif-unread-item' : '')
                }
                onClick={() => handleNotificationClick(notification)}
              >
                <span className="shopease-notif-icon">
                  {notification.isRead ? '📩' : '✉️'}
                </span>
                <span className="shopease-notif-body">
                  <span className="shopease-notif-title">
                    {notification.title}
                    {!notification.isRead && (
                      <span className="shopease-notif-dot" />
                    )}
                  </span>
                  <span className="shopease-notif-msg">
                    {notification.message}
                  </span>
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </NavDropdown>
  );

  /* Profile / auth menu (reused inline on desktop and mobile) */
  const renderUser = (id) => (
    <Nav className="align-items-xl-center shopease-user-nav">
      {user ? (
        <NavDropdown
          title={<span className="shopease-username">👤 {user.name}</span>}
          id={id}
          align="end"
        >
          <div className="shopease-user-head">
            <span className="shopease-user-lamp">🪔</span>
            <span>
              Welcome,
              <strong className="d-block">{user.name}</strong>
            </span>
          </div>

          <NavDropdown.Item as={Link} to="/profile">
            🙏 My Profile
          </NavDropdown.Item>

          <NavDropdown.Item as={Link} to="/orders">
            📦 My Orders
          </NavDropdown.Item>

          <NavDropdown.Item as={Link} to="/my-tickets">
            🎫 My Tickets
          </NavDropdown.Item>

          <NavDropdown.Item as={Link} to="/wishlist">
            ❤️ Wishlist
          </NavDropdown.Item>

          <NavDropdown.Item as={Link} to="/cart">
            🛒 Cart
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/my-refunds">
            💰 My Refunds
          </NavDropdown.Item>

          {JSON.parse(localStorage.getItem('userInfo'))?.isAdmin && (
            <>
              <NavDropdown.Divider />

              <NavDropdown.Item as={Link} to="/admin">
                👨‍💼 Admin Dashboard
              </NavDropdown.Item>
            </>
          )}

          <NavDropdown.Divider />

          <NavDropdown.Item onClick={logoutHandler}>Logout</NavDropdown.Item>
        </NavDropdown>
      ) : (
        <>
          <Nav.Link as={Link} to="/login">
            Login
          </Nav.Link>

          <Nav.Link as={Link} to="/signup">
            Sign Up
          </Nav.Link>
        </>
      )}
    </Nav>
  );

  return (
    <Navbar
      variant="dark"
      expand="xl"
      sticky="top"
      className="shadow-lg shopease-navbar py-2"
    >
      <style>{navbarStyles}</style>

      <Container fluid className="px-3 px-md-4 pe-xl-5">
        <Navbar.Brand as={Link} to="/" className="fw-bold shopease-brand">
          <span className="shopease-brand-badge">🕉️</span>
          <span className="d-flex flex-column lh-1">
            <span className="shopease-brand-text">PoojaMart</span>
            <span className="shopease-brand-tag">Divine Essentials</span>
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />

        {/* Mobile: a big, full-width search bar below the brand.
            Notifications float near ShopGenie; profile lives in the bottom nav. */}
        <div className="shopease-mobile-bar d-xl-none order-3 w-100 mt-2">
          <div className="shopease-search shopease-search-mobile position-relative w-100">
            {searchInner}
          </div>
        </div>

        <Navbar.Collapse id="main-navbar" className="align-items-xl-center">
          <Nav
            className="mx-auto align-items-xl-center shopease-nav"
            style={{
              gap: '4px'
            }}
          >
            <Nav.Link as={Link} to="/" active={isActive('/')}>
              🏠 Home
            </Nav.Link>

            <Nav.Link as={Link} to="/products" active={isActive('/products')}>
              🛍️ Products
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/categories"
              active={isActive('/categories')}
            >
              📂 Categories
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/orders"
              active={isActive('/orders')}
              className="d-flex align-items-center gap-1"
              style={{ whiteSpace: 'nowrap' }}
            >
              📦 Orders
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/help"
              active={isActive('/help')}
              className="d-flex align-items-center gap-1"
              style={{ whiteSpace: 'nowrap' }}
            >
              🛟 Help
            </Nav.Link>

            {JSON.parse(localStorage.getItem('userInfo'))?.isAdmin && (
              <Nav.Link
                as={Link}
                to="/admin"
                active={isActive('/admin')}
                className="d-flex align-items-center gap-1"
                style={{ whiteSpace: 'nowrap' }}
              >
                👨‍💼 Admin
              </Nav.Link>
            )}
          </Nav>

          <div className="shopease-search position-relative me-xl-2 my-3 my-xl-0 d-none d-xl-block">
            {searchInner}
          </div>

          {/* Desktop: bell + profile inline on the right (mobile copies live
              beside the search bar above) */}
          <div className="d-none d-xl-flex align-items-center">
            {renderNotif('notification-menu')}
            {renderUser('user-menu')}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

const navbarStyles = `
  /* Stop the whole page from scrolling sideways */
  html, body {
    overflow-x: hidden;
    max-width: 100%;
  }

  .shopease-navbar {
    position: relative;
    background:
      radial-gradient(900px 200px at 12% -40%, rgba(251,191,36,0.22), transparent 70%),
      linear-gradient(90deg, #3b0764 0%, #7c2d12 45%, #9a3412 70%, #b45309 100%);
    background-size: 160% 100%;
    animation: shopeaseSheen 16s ease infinite;
    border-bottom: 1px solid rgba(251,191,36,0.35);
  }
  @keyframes shopeaseSheen {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  /* Shimmering divine gold thread along the top */
  .shopease-navbar::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(90deg,
      transparent, #fde68a 20%, #f59e0b 50%, #fde68a 80%, transparent);
    background-size: 200% 100%;
    animation: shopeaseThread 6s linear infinite;
  }
  @keyframes shopeaseThread {
    from { background-position: 200% 0; }
    to { background-position: -200% 0; }
  }

  .shopease-brand {
    font-size: 1.6rem;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .shopease-brand-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px; height: 44px;
    border-radius: 50%;
    font-size: 1.4rem;
    background: radial-gradient(circle at 35% 30%, #fef3c7, #f59e0b 60%, #b45309);
    box-shadow:
      0 0 0 2px rgba(253,230,138,0.55),
      0 0 18px rgba(245,158,11,0.6),
      inset 0 1px 3px rgba(255,255,255,0.6);
    animation: shopeaseGlow 3.5s ease-in-out infinite;
  }
  @keyframes shopeaseGlow {
    0%, 100% { box-shadow: 0 0 0 2px rgba(253,230,138,0.55), 0 0 14px rgba(245,158,11,0.45), inset 0 1px 3px rgba(255,255,255,0.6); }
    50% { box-shadow: 0 0 0 2px rgba(253,230,138,0.8), 0 0 26px rgba(245,158,11,0.8), inset 0 1px 3px rgba(255,255,255,0.6); }
  }
  .shopease-brand-text {
    font-size: 1.45rem;
    font-weight: 800;
    background: linear-gradient(90deg, #fde68a, #fbbf24 40%, #fb923c);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: 0.5px;
  }
  .shopease-brand-tag {
    font-size: 0.58rem;
    font-weight: 600;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: rgba(253,230,138,0.75);
    margin-top: 3px;
  }

  .shopease-nav .nav-link {
    position: relative;
    color: rgba(255,255,255,0.82) !important;
    font-weight: 500;
    border-radius: 10px;
    padding: 6px 9px !important;
    white-space: nowrap;
    transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
  }
  /* Gold underline that grows on hover */
  .shopease-nav .nav-link::after {
    content: '';
    position: absolute;
    left: 12px; right: 12px; bottom: 3px;
    height: 2px; border-radius: 2px;
    background: linear-gradient(90deg, #fde68a, #f59e0b);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.25s ease;
  }
  .shopease-nav .nav-link:hover {
    color: #fff !important;
    background: rgba(253,230,138,0.14);
    transform: translateY(-1px);
  }
  .shopease-nav .nav-link:hover::after { transform: scaleX(1); }
  .shopease-nav .nav-link.active {
    color: #3b0764 !important;
    background: linear-gradient(135deg, #fde68a, #fbbf24);
    font-weight: 700;
    box-shadow: 0 3px 10px rgba(245,158,11,0.4);
  }
  .shopease-nav .nav-link.active::after { transform: scaleX(0); }

  .shopease-search {
    width: 210px;
    max-width: 100%;
    flex-shrink: 1;
  }
  @media (min-width: 1400px) {
    .shopease-search { width: 270px; }
  }

  /* Desktop: tuck the nav links right up against the brand, then let the search
     stretch across whatever room is left so the row has no dead gap in it. */
  @media (min-width: 1200px) {
    .shopease-navbar .shopease-nav {
      margin-left: 0.25rem !important;
      margin-right: 0 !important;
    }

    /* The search takes the slack the nav's auto margin used to swallow, so the
       row reads brand → links → search → profile with no dead gap. No cap and
       no auto margin anywhere after it: an auto margin would eat the free
       space before flex-grow ever ran, and the bar would never widen. */
    .shopease-navbar .shopease-search {
      flex: 1 1 auto;
      width: auto;
      min-width: 190px;
      max-width: none;
      margin-left: 0.9rem;
    }

    /* The single row must never grow past the viewport — if it does, the
       profile is the thing that falls off the right edge. Keeping the row
       nowrap and letting the flex children drop to min-width: 0 means the
       gaps absorb the pressure instead of the last item. */
    .shopease-navbar > .container-fluid {
      flex-wrap: nowrap;
      padding-right: 1rem !important;
    }
    .shopease-navbar .navbar-collapse {
      min-width: 0;
    }
    .shopease-navbar .shopease-nav {
      min-width: 0;
    }
    .shopease-brand {
      flex: 0 0 auto;
    }
    /* the right-hand group is the one thing that must stay whole */
    .shopease-navbar .navbar-collapse > .d-xl-flex {
      flex: 0 0 auto;
    }
  }

  /* Between the xl breakpoint and ~1600px the row is genuinely tight, so trim
     the fixed costs: a smaller brand lockup, tighter link padding, a shorter
     search field. Full sizing returns above 1600px where there's room. */
  @media (min-width: 1200px) and (max-width: 1599.98px) {
    .shopease-brand {
      gap: 8px;
      margin-right: 0.5rem !important;
    }
    .shopease-brand-badge {
      width: 38px; height: 38px;
      font-size: 1.2rem;
    }
    .shopease-brand-text {
      font-size: 1.2rem;
      letter-spacing: 0.2px;
    }
    .shopease-brand-tag {
      font-size: 0.5rem;
      letter-spacing: 1.6px;
    }
    .shopease-nav .nav-link {
      padding: 6px 6px !important;
      font-size: 0.94rem;
    }
    .shopease-nav .nav-link::after { left: 8px; right: 8px; }
    /* Let the search absorb any leftover pressure, never the links */
    .shopease-nav { flex-shrink: 0; }
    .shopease-icon-dd .dropdown-toggle,
    .shopease-user-nav .dropdown-toggle {
      padding: 6px 7px !important;
    }
    .shopease-username { max-width: 96px; }
  }

  /* Keep the profile dropdown clear of the right edge / scrollbar */
  .shopease-user-nav {
    padding-right: 6px;
  }
  .shopease-user-nav .dropdown-menu {
    margin-right: 4px;
  }

  /* Right-side dropdown toggles (bell + user) — consistent alignment */
  .shopease-icon-dd .dropdown-toggle,
  .shopease-user-nav .dropdown-toggle {
    display: inline-flex !important;
    align-items: center;
    gap: 4px;
    color: rgba(255,255,255,0.9) !important;
    font-weight: 500;
    padding: 6px 10px !important;
    border-radius: 8px;
    transition: background 0.2s ease;
  }
  .shopease-icon-dd .dropdown-toggle:hover,
  .shopease-user-nav .dropdown-toggle:hover {
    background: rgba(255,255,255,0.12);
  }
  .shopease-icon-dd .dropdown-toggle { font-size: 1.15rem; }

  /* Keep a long username from pushing the row off screen */
  .shopease-username {
    display: inline-block;
    max-width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  .shopease-search-input {
    border-radius: 50px 0 0 50px;
    border: 1px solid rgba(253,230,138,0.4);
    border-right: none;
    padding-left: 18px;
    background: rgba(255,255,255,0.96);
  }
  .shopease-search-input:focus {
    background: #fff;
    border-color: #fbbf24;
    box-shadow: 0 0 0 0.2rem rgba(251,191,36,0.35);
  }
  .shopease-search-btn {
    border-radius: 0 50px 50px 0;
    border: none;
    background: linear-gradient(135deg, #f59e0b, #ea580c);
    color: #fff;
  }
  .shopease-search-btn:hover {
    background: linear-gradient(135deg, #fbbf24, #f97316);
  }

  .shopease-suggestions {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    min-width: 300px;
    z-index: 9999;
    max-height: min(70vh, 420px);
    overflow-y: auto;
    background: linear-gradient(160deg, #1a0611 0%, #460d16 55%, #7c2d12 100%);
    border: 1px solid rgba(253, 230, 138, 0.32);
    border-radius: 16px;
    box-shadow: 0 22px 48px rgba(20, 6, 2, 0.5);
    padding: 6px;
    transform-origin: top center;
    animation: shopeaseDrop 0.18s ease;
    scrollbar-width: thin;
    scrollbar-color: rgba(253, 230, 138, 0.45) transparent;
  }
  /* Gold thread travelling across the top of the panel */
  .shopease-suggestions::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    border-radius: 16px 16px 0 0;
    background: linear-gradient(90deg, transparent, #fde68a 20%, #f59e0b 50%, #fde68a 80%, transparent);
    background-size: 200% 100%;
    animation: notifThread 4.5s linear infinite;
  }
  @keyframes shopeaseDrop {
    from { opacity: 0; transform: translateY(-6px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  .shopease-suggestions::-webkit-scrollbar { width: 8px; }
  .shopease-suggestions::-webkit-scrollbar-track { background: transparent; }
  .shopease-suggestions::-webkit-scrollbar-thumb {
    background: rgba(253, 230, 138, 0.4);
    border-radius: 8px;
  }

  .shopease-suggestions-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 12px 7px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: rgba(253, 230, 138, 0.85);
    border-bottom: 1px solid rgba(253, 230, 138, 0.18);
    margin-bottom: 4px;
  }
  .shopease-suggestions-count {
    background: linear-gradient(135deg, #fde68a, #fbbf24);
    color: #3b1206;
    font-weight: 700;
    border-radius: 20px;
    padding: 1px 9px;
    font-size: 0.7rem;
    animation: notifNewPulse 2.2s ease-in-out infinite;
  }

  /* Rows arrive one after another as the panel drops */
  .shopease-suggestion-item {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 9px 10px;
    border-radius: 12px;
    text-decoration: none;
    color: rgba(245, 230, 200, 0.9);
    transition: background 0.2s ease, padding-left 0.2s ease;
    animation: userItemIn 0.32s ease both;
  }
  .shopease-suggestion-item:nth-child(2) { animation-delay: 0.04s; }
  .shopease-suggestion-item:nth-child(3) { animation-delay: 0.08s; }
  .shopease-suggestion-item:nth-child(4) { animation-delay: 0.12s; }
  .shopease-suggestion-item:nth-child(5) { animation-delay: 0.16s; }
  .shopease-suggestion-item:nth-child(6) { animation-delay: 0.20s; }
  .shopease-suggestion-item + .shopease-suggestion-item {
    border-top: 1px solid rgba(253, 230, 138, 0.14);
    border-radius: 0 0 12px 12px;
  }
  .shopease-suggestion-item:hover {
    background: rgba(253, 230, 138, 0.14);
    color: #fff7ed;
    padding-left: 18px;
  }
  /* Gold wick lighting up the row */
  .shopease-suggestion-item::before {
    content: '';
    position: absolute;
    left: 2px; top: 50%;
    width: 3px; height: 0;
    border-radius: 3px;
    background: linear-gradient(180deg, #fde68a, #f59e0b);
    box-shadow: 0 0 10px rgba(251, 191, 36, 0.8);
    transform: translateY(-50%);
    transition: height 0.25s ease;
  }
  .shopease-suggestion-item:hover::before { height: 60%; }
  /* A pass of light as the pointer lands */
  .shopease-suggestion-item::after {
    content: '';
    position: absolute;
    top: 0; left: -60%;
    width: 45%; height: 100%;
    background: linear-gradient(100deg, transparent, rgba(253, 230, 138, 0.3), transparent);
    transform: skewX(-18deg);
    pointer-events: none;
    transition: left 0.55s ease;
  }
  .shopease-suggestion-item:hover::after { left: 130%; }

  .shopease-sg-thumb {
    flex-shrink: 0;
    width: 50px; height: 50px;
    border-radius: 12px;
    padding: 2px;
    background: linear-gradient(135deg, #fde68a, #f59e0b);
    box-shadow: 0 3px 10px rgba(245,158,11,0.45);
    transition: box-shadow 0.25s ease, transform 0.25s ease;
  }
  .shopease-suggestion-item:hover .shopease-sg-thumb {
    transform: scale(1.06);
    box-shadow: 0 0 16px rgba(251, 191, 36, 0.75);
  }
  .shopease-sg-thumb img {
    width: 100%; height: 100%;
    object-fit: cover;
    border-radius: 10px;
    background: #fff;
    display: block;
  }
  .shopease-sg-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
  }
  .shopease-sg-name {
    font-weight: 700;
    font-size: 0.92rem;
    color: #fde68a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .shopease-sg-cat {
    font-size: 0.75rem;
    color: rgba(245, 230, 200, 0.65);
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .shopease-sg-price {
    flex-shrink: 0;
    font-weight: 800;
    font-size: 0.85rem;
    color: #86efac;
    background: rgba(34, 197, 94, 0.16);
    border: 1px solid rgba(134, 239, 172, 0.35);
    border-radius: 20px;
    padding: 3px 10px;
  }
  .shopease-sg-arrow {
    flex-shrink: 0;
    font-size: 1.3rem;
    line-height: 1;
    color: #fbbf24;
    opacity: 0;
    transform: translateX(-4px);
    transition: opacity 0.15s ease, transform 0.15s ease;
  }
  .shopease-suggestion-item:hover .shopease-sg-arrow {
    opacity: 1;
    transform: translateX(0);
  }

  @media (prefers-reduced-motion: reduce) {
    .shopease-suggestions,
    .shopease-suggestions::before,
    .shopease-suggestions-count,
    .shopease-suggestion-item { animation: none; }
    .shopease-suggestion-item::after { display: none; }
  }

  @media (max-width: 575.98px) {
    .shopease-suggestions { min-width: 0; }
    .shopease-sg-thumb { width: 44px; height: 44px; }
    .shopease-sg-name { font-size: 0.86rem; }
    .shopease-sg-price { font-size: 0.8rem; padding: 2px 8px; }
    .shopease-sg-arrow { display: none; }
  }

  /* Dropdown menus */
  .shopease-icon-dd .dropdown-menu,
  .shopease-user-nav .dropdown-menu {
    border: none;
    border-radius: 14px;
    box-shadow: 0 12px 30px rgba(0,0,0,0.18);
    margin-top: 8px;
  }
  .shopease-icon-dd .dropdown-menu {
    padding: 0;
    overflow: hidden;
  }

  /* ===== Profile menu — sanctum panel ===== */
  .shopease-user-nav .dropdown-menu {
    position: relative;
    overflow: hidden;
    min-width: 244px;
    padding: 0 0 6px;
    background: linear-gradient(160deg, #1a0611 0%, #460d16 55%, #7c2d12 100%);
    border: 1px solid rgba(253, 230, 138, 0.32) !important;
    box-shadow: 0 22px 48px rgba(20, 6, 2, 0.5);
  }
  /* Gold thread travelling across the top of the panel */
  .shopease-user-nav .dropdown-menu::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    z-index: 2;
    background: linear-gradient(90deg, transparent, #fde68a 20%, #f59e0b 50%, #fde68a 80%, transparent);
    background-size: 200% 100%;
    animation: notifThread 4.5s linear infinite;
  }

  /* Greeting with a burning lamp */
  .shopease-user-head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    margin-bottom: 4px;
    color: rgba(245, 230, 200, 0.75);
    font-size: 0.76rem;
    letter-spacing: 0.4px;
    border-bottom: 1px solid rgba(253, 230, 138, 0.18);
  }
  .shopease-user-head strong {
    color: #fde68a;
    font-size: 0.95rem;
    letter-spacing: 0;
  }
  .shopease-user-lamp {
    font-size: 1.15rem;
    line-height: 1;
    animation: userLamp 2.4s ease-in-out infinite;
  }
  @keyframes userLamp {
    0%, 100% { transform: scale(1)    rotate(-3deg); filter: drop-shadow(0 0 5px rgba(251,191,36,0.5)); }
    30%      { transform: scale(1.14) rotate(4deg);  filter: drop-shadow(0 0 13px rgba(251,191,36,0.95)); }
    62%      { transform: scale(0.95) rotate(-4deg); filter: drop-shadow(0 0 7px rgba(251,191,36,0.6)); }
  }

  /* Items light up on hover, and slide in when the menu opens */
  .shopease-user-nav .dropdown-item {
    position: relative;
    overflow: hidden;
    color: rgba(245, 230, 200, 0.9);
    font-weight: 500;
    padding: 9px 16px;
    transition: color 0.2s ease, padding-left 0.2s ease, background 0.2s ease;
  }
  .shopease-user-nav .dropdown-item:hover,
  .shopease-user-nav .dropdown-item:focus {
    color: #fff7ed;
    background: rgba(253, 230, 138, 0.14);
    padding-left: 22px;
  }
  /* Gold wick lighting up the left edge of the hovered row */
  .shopease-user-nav .dropdown-item::before {
    content: '';
    position: absolute;
    left: 0; top: 50%;
    width: 3px; height: 0;
    border-radius: 3px;
    background: linear-gradient(180deg, #fde68a, #f59e0b);
    box-shadow: 0 0 10px rgba(251, 191, 36, 0.8);
    transform: translateY(-50%);
    transition: height 0.25s ease;
  }
  .shopease-user-nav .dropdown-item:hover::before { height: 62%; }
  /* A pass of light sweeps the row as the pointer lands */
  .shopease-user-nav .dropdown-item::after {
    content: '';
    position: absolute;
    top: 0; left: -60%;
    width: 45%; height: 100%;
    background: linear-gradient(100deg, transparent, rgba(253, 230, 138, 0.28), transparent);
    transform: skewX(-18deg);
    pointer-events: none;
    transition: left 0.55s ease;
  }
  .shopease-user-nav .dropdown-item:hover::after { left: 130%; }

  .shopease-user-nav .dropdown-divider {
    border-top: 1px solid rgba(253, 230, 138, 0.2);
    margin: 6px 0;
  }

  /* Rows arrive one after another as the panel opens */
  .shopease-user-nav .dropdown-menu.show .dropdown-item {
    animation: userItemIn 0.32s ease both;
  }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(2)  { animation-delay: 0.03s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(3)  { animation-delay: 0.06s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(4)  { animation-delay: 0.09s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(5)  { animation-delay: 0.12s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(6)  { animation-delay: 0.15s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(7)  { animation-delay: 0.18s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(8)  { animation-delay: 0.21s; }
  .shopease-user-nav .dropdown-menu.show .dropdown-item:nth-child(9)  { animation-delay: 0.24s; }
  @keyframes userItemIn {
    from { opacity: 0; transform: translateX(-10px); }
    to   { opacity: 1; transform: translateX(0); }
  }

  @media (prefers-reduced-motion: reduce) {
    .shopease-user-nav .dropdown-menu::before,
    .shopease-user-lamp,
    .shopease-user-nav .dropdown-menu.show .dropdown-item { animation: none; }
    .shopease-user-nav .dropdown-item::after { display: none; }
  }

  /* Notification panel */
  .shopease-notif {
    width: 340px;
    max-width: 92vw;
  }
  /* Sanctum header with a gold thread running beneath it */
  .shopease-notif-header {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    color: #fde68a;
    background: linear-gradient(120deg, #1a0611, #460d16 38%, #7c2d12 72%, #b45309);
  }
  .shopease-notif-header::after {
    content: '';
    position: absolute;
    left: 0; right: 0; bottom: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #fde68a 20%, #f59e0b 50%, #fde68a 80%, transparent);
    background-size: 200% 100%;
    animation: notifThread 4.5s linear infinite;
  }
  @keyframes notifThread {
    from { background-position: 200% 0; }
    to   { background-position: -200% 0; }
  }

  /* Temple bell — still, then a peal that damps out */
  .shopease-notif-bell {
    display: inline-block;
    transform-origin: 50% 10%;
    animation: notifTempleBell 6.5s ease-in-out infinite;
  }
  @keyframes notifTempleBell {
    0%, 60%, 100% { transform: rotate(0deg); }
    64% { transform: rotate(16deg); }
    68% { transform: rotate(-13deg); }
    72% { transform: rotate(9deg); }
    76% { transform: rotate(-6deg); }
    80% { transform: rotate(3deg); }
    85% { transform: rotate(-1deg); }
  }

  .shopease-notif-unread {
    background: linear-gradient(135deg, #fde68a, #fbbf24);
    color: #3b1206;
    font-size: 0.72rem;
    font-weight: 700;
    border-radius: 30px;
    padding: 3px 10px;
    animation: notifNewPulse 2.2s ease-in-out infinite;
  }
  @keyframes notifNewPulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.65); }
    50%      { box-shadow: 0 0 0 8px rgba(251, 191, 36, 0); }
  }

  /* The silenced bell sways while there's nothing to report */
  .shopease-notif-empty-icon {
    font-size: 2rem;
    display: inline-block;
    transform-origin: 50% 12%;
    animation: notifIdleSway 4.5s ease-in-out infinite;
  }
  @keyframes notifIdleSway {
    0%, 100% { transform: rotate(-6deg); }
    50%      { transform: rotate(6deg); }
  }
  .shopease-notif-list {
    max-height: 360px;
    overflow-y: auto;
    background: linear-gradient(160deg, #1a0611 0%, #460d16 55%, #7c2d12 100%);
    scrollbar-width: thin;
    scrollbar-color: rgba(253, 230, 138, 0.45) transparent;
  }
  .shopease-notif-list::-webkit-scrollbar { width: 8px; }
  .shopease-notif-list::-webkit-scrollbar-track { background: transparent; }
  .shopease-notif-list::-webkit-scrollbar-thumb {
    background: rgba(253, 230, 138, 0.4);
    border-radius: 8px;
  }

  .shopease-notif-item {
    position: relative;
    overflow: hidden;
    display: flex;
    gap: 12px;
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(253, 230, 138, 0.16);
    cursor: pointer;
    transition: background 0.2s ease, padding-left 0.2s ease;
  }
  .shopease-notif-item:hover {
    background: rgba(253, 230, 138, 0.14);
    padding-left: 22px;
  }
  /* Gold wick lighting up the row */
  .shopease-notif-item::before {
    content: '';
    position: absolute;
    left: 0; top: 50%;
    width: 3px; height: 0;
    border-radius: 3px;
    background: linear-gradient(180deg, #fde68a, #f59e0b);
    box-shadow: 0 0 10px rgba(251, 191, 36, 0.8);
    transform: translateY(-50%);
    transition: height 0.25s ease;
  }
  .shopease-notif-item:hover::before { height: 60%; }
  /* A pass of light as the pointer lands */
  .shopease-notif-item::after {
    content: '';
    position: absolute;
    top: 0; left: -60%;
    width: 45%; height: 100%;
    background: linear-gradient(100deg, transparent, rgba(253, 230, 138, 0.28), transparent);
    transform: skewX(-18deg);
    pointer-events: none;
    transition: left 0.55s ease;
  }
  .shopease-notif-item:hover::after { left: 130%; }

  .shopease-notif-unread-item {
    background: rgba(253, 230, 138, 0.08);
  }
  .shopease-notif-icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(253, 230, 138, 0.16);
    border: 1px solid rgba(253, 230, 138, 0.35);
    font-size: 1rem;
  }

  /* Rows arrive one after another as the panel opens */
  .shopease-icon-dd .dropdown-menu.show .shopease-notif-item {
    animation: userItemIn 0.32s ease both;
  }
  .shopease-icon-dd .dropdown-menu.show .shopease-notif-item:nth-child(2) { animation-delay: 0.04s; }
  .shopease-icon-dd .dropdown-menu.show .shopease-notif-item:nth-child(3) { animation-delay: 0.08s; }
  .shopease-icon-dd .dropdown-menu.show .shopease-notif-item:nth-child(4) { animation-delay: 0.12s; }
  .shopease-icon-dd .dropdown-menu.show .shopease-notif-item:nth-child(5) { animation-delay: 0.16s; }
  .shopease-icon-dd .dropdown-menu.show .shopease-notif-item:nth-child(6) { animation-delay: 0.20s; }
  .shopease-notif-body {
    min-width: 0;
    flex: 1;
  }
  .shopease-notif-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    font-size: 0.88rem;
    color: #fde68a;
  }
  /* Unread envelopes sit in a breathing lamp-glow */
  .shopease-notif-unread-item .shopease-notif-icon {
    animation: notifAura 3.2s ease-in-out infinite;
  }
  @keyframes notifAura {
    0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.3); }
    50%      { box-shadow: 0 0 16px 3px rgba(245, 158, 11, 0.6); }
  }

  /* The unread dot burns like a small diya */
  .shopease-notif-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f59e0b;
    flex-shrink: 0;
    animation: notifLamp 1.7s ease-in-out infinite;
  }
  @keyframes notifLamp {
    0%, 100% { opacity: 0.65; transform: scale(1);    box-shadow: 0 0 0 0 rgba(245,158,11,0.7); }
    50%      { opacity: 1;    transform: scale(1.25); box-shadow: 0 0 9px 2px rgba(245,158,11,0.8); }
  }

  @media (prefers-reduced-motion: reduce) {
    .shopease-notif-header::after,
    .shopease-notif-bell,
    .shopease-notif-unread,
    .shopease-notif-unread-item .shopease-notif-icon,
    .shopease-notif-dot,
    .shopease-notif-empty-icon,
    .shopease-icon-dd .dropdown-menu.show .shopease-notif-item { animation: none; }
    .shopease-notif-item::after { display: none; }
  }
  .shopease-notif-msg {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 0.8rem;
    color: rgba(245, 230, 200, 0.72);
    margin-top: 2px;
  }
  .shopease-notif-empty {
    text-align: center;
    padding: 28px 16px;
    color: #fde68a;
    background: linear-gradient(160deg, #1a0611 0%, #460d16 55%, #7c2d12 100%);
  }
  .shopease-notif-empty .text-muted {
    color: rgba(245, 230, 200, 0.65) !important;
  }

  /* Collapsed menu (tablet / mobile) */
  @media (max-width: 1199.98px) {
    .shopease-search { width: 100%; }
    .shopease-nav { padding-top: 6px; }
    .shopease-nav .nav-link {
      padding: 10px 14px !important;
      margin-bottom: 2px;
    }
    .shopease-nav .nav-link::after { display: none; }
    .shopease-nav .nav-link.active { display: inline-block; }
    /* Give the expanded menu a soft divine panel on mobile */
    .navbar-collapse {
      background: rgba(59,7,100,0.25);
      border: 1px solid rgba(253,230,138,0.2);
      border-radius: 16px;
      padding: 10px 12px;
      margin-top: 10px;
      backdrop-filter: blur(4px);
    }

    /* Big, full-width mobile search bar for easy searching */
    .shopease-mobile-bar .shopease-search-input {
      height: 50px;
      font-size: 1rem;
      padding-left: 20px;
    }
    .shopease-mobile-bar .shopease-search-btn {
      min-width: 60px;
      font-size: 1.25rem;
    }
  }

  @media (max-width: 575.98px) {
    .shopease-brand { font-size: 1.35rem; }
    .shopease-brand-badge { width: 38px; height: 38px; font-size: 1.2rem; }
    .shopease-brand-text { font-size: 1.2rem; }
  }

  /* Toggler in warm gold to match the theme */
  .shopease-navbar .navbar-toggler {
    border-color: rgba(253,230,138,0.45);
  }
  .shopease-navbar .navbar-toggler:focus {
    box-shadow: 0 0 0 0.2rem rgba(251,191,36,0.35);
  }
`;

export default CustomNavbar;
